export default __webpack_public_path__ + "static/media/spoj.a30be1cb.webp";